import _      from 'lodash';
import geolib from 'geolib';

const NEARBY_COUNT   = 3;
const UNIT_THRESHOLD = 500;

export const displayDistance = (distance, stub = ' away') => {
    let units;
    if (distance >= UNIT_THRESHOLD)
    {
        units = 'km';
        distance = _.round((distance / 1000), 2);
    }
    else
    {
        units    = (distance === 1) ? 'metre' : 'metres';
        distance = _.round(distance, 0);
    }

    return distance + ' ' + units + stub;
};

/**
 * Calculate and add the distance key to all place objects
 *
 * @param coords
 * @param places
 * @returns {Array|*}
 */
export const calculateDistance = (coords, places) =>
{
    _.forEach(places, (place, key) =>
    {
        let from = { latitude: coords.latitude, longitude: coords.longitude };
        let to   = { latitude: place.coords.lat, longitude: place.coords.long };

        let distance = geolib.getDistance(from, to);
        places[key] = { ...places[key], distance: distance };
    });

    places = _.orderBy(places, 'distance', 'asc');

    return places;
};

/**
 * Remove the 'distance' key from place objects
 *
 * @param places
 * @returns {Array|*}
 */
export const removeDistance = (places) =>
{
    _.forEach(places, (place, key) => {
        places[key] = _.omit(place, 'distance');
    });

    places = _.orderBy(places, 'name', 'asc');

    return places;
};

/**
 *
 *
 * @param places
 * @returns {*}
 */
export const calculateNearBy = (places) =>
{
    let placesFrom = JSON.parse(JSON.stringify(places));
    let placesTo   = JSON.parse(JSON.stringify(places));

    _.forEach(placesFrom, (placeFrom, key) => {
        places[key].nearby = [];
        let calculated     = [];

        _.forEach(placesTo, (placeTo) => {
            if (placeFrom.id !== placeTo.id)
            {
                let from = { latitude: placeFrom.coords.lat, longitude: placeFrom.coords.long };
                let to   = { latitude: placeTo.coords.lat, longitude: placeTo.coords.long };

                let distance = geolib.getDistance(from, to);
                placeTo      = { ...placeTo, distance: distance };

                calculated.push({ place: placeTo, distance: distance });
            }
        });

        let sorted  = _.orderBy(calculated, 'distance', 'asc');
        let nearest = _.slice(sorted, 0, NEARBY_COUNT);

        _.forEach(nearest, (nearestPlace) => {
            places[key].nearby.push(nearestPlace.place);
        });
    });

    return places;
};



// WEBPACK FOOTER //
// ./src/classes/Distance.js